import { isProd, isStage } from "../api/config";
import { type PostHogConfig } from "posthog-js";

const posthogPublicKeyProduction =
  "phc_ExdgLzORpXEk0zImSxFrx8lc6KI5p9rTUXFbVGHvsnC";

const posthogPublicKeyStaging =
  "phc_PxrOQPKnmUOqoBu7o3Azl5kVsduTKW1O63QOgocusUV";

const posthogPublicKeyDevelopment =
  "phc_ml3qJFdd7KKBPv1h0TfKWNLrYeJxQ1fxV6i8XOIbsne";

export const posthogKey = isProd
  ? posthogPublicKeyProduction
  : isStage
    ? posthogPublicKeyStaging
    : posthogPublicKeyDevelopment;

export const config: Partial<PostHogConfig> = {
  api_host: `/nha`,
  ui_host: "https://eu.i.posthog.com",
  capture_pageleave: true,
  autocapture: {
    dom_event_allowlist: ["click"],
    element_allowlist: ["a"],
  },
  cookieless_mode: "on_reject",
  capture_performance: false,
  capture_exceptions: true,
};
